/**************************************************
 * Nombre:        Formulario_Pregunta_Test
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {CheckCircle} from '@mui/icons-material'

const Formulario_Pregunta_Test = ({...props}) => {
    const [opciones, setOpciones] = useState([]);
    const [pregunta, setPregunta] = useState({});
    const [index, setIndex] = useState(0);


    useEffect(() => {

        let pregunta = props.pregunta
        let index = props.index
        if (pregunta) {
            setPregunta(pregunta)
            let opciones = pregunta.opciones;
            let arr = []
            for (let i = 0; i < opciones.length; i++) {
                arr.push(i + 1);
            }
            setOpciones(arr)
        }

        if (index){
            setIndex(index)
        }


    }, []);

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-end'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 18}}>{pregunta.pregunta}</Typography>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    {pregunta.opciones &&  pregunta.opciones.map((it, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 14}}><span style={{fontWeight: 600, paddingRight: 5}} >{index + 1}.</span>{it}</Typography>
                        </Grid>
                    ))}

                </Grid>


                <Grid container size={4} justifyContent={'flex-end'}>
                    <IngresoSelect Icono={CheckCircle} nombre={'Respuesta'} dato={'respuesta'+index} {...props}
                                   opciones={opciones}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pregunta_Test